import axios from "../axiosClient";

export const getBaselineListByModuleId = async ({
  baselineModuleId,
  blockCode,
  assetCode,
}: any) => {
  const res = await axios.post(
    `/slpapp/Baseline/BaselineListByModuleId`,
    {},
    {
      params: { baselineModuleId, blockCode, assetCode },
    }
  );

  return res?.data;
};

export const getBaselines = async (
  PageNumber: any,
  pageSize: any,
  SortBy: any,
  SortDirection: any,
  searchText: any,
  signal: any
) => {
  const res = await axios.get(`/slpapp/Baseline/BaselineList`, {
    params: { PageNumber, pageSize, SortBy, SortDirection, searchText },
    signal,
  });

  return res?.data;
};
